<template>
	<div id="header">
		<div class="target  flex-between">
			<p class="target-p">
				您好,欢迎来到 国联易拍 拍卖平台!
				<span style="margin-left: 16px;" v-if="!token">
					请
					<span class="pointer-hover" style="color: #0E71BC;" @click="gologin()">登录/</span>
					<span class="pointer-hover" style="color: #0E71BC;" @click="goregister()">注册</span>
				</span>
				<span v-else>
					<span class="pointer-hover" @click="gologin()">欢迎{{userInfo.username}},</span>
					点击
					<span class="pointer-hover" style="color: #0E71BC;" @click="logout()">退出登录</span>
				</span>
			</p>
			<div class="target-div flex-center">
				<img src="../assets/img/header/Phone-call.png" alt="加载失败服务热线" title="服务热线" />
				<span>服务热线:</span>
				<span style="color: #0E71BC;">158-3000-0223</span>
				<span class="spacer"></span>
				<span class="pointer-hover" @click="myauction()">我的拍卖</span>
				<span class="spacer"></span>
				<span class="pointer-hover" @click="helpcenter()">帮助中心</span>
			</div>

		</div>
		<div class="header">
			<div class="gl-logo-searh flex-between">
				<div class="gl-logo-searh-left  flex-between">
					<a href="/" target="_blank" class="logo"></a>
					<ul class="flex-between">
						<li>阳光拍卖</li>
						<li>
							<span></span>
						</li>
						<li>数字盘活</li>
						<li>
							<span></span>
						</li>
						<li>
							价值增值
						</li>
					</ul>
				</div>
				<div class="gl-logo-search-right flex-between">
					<input v-model="keyWord" class="input-search" placeholder="请输入标的名称" type="text"
						@keydown.enter="handleSearch" />
					<div class="search pointer-hover flex-center" @click="handleSearch()">
						<img src="../assets/img/header/Search.png" alt="" />
					</div>
				</div>
			</div>
			<div class="gl-nav flex-between">
				<ul class="flex-between">
					<li @click="navigation(item)" v-for="item in navBarList"
						:class="item.isActive === true ? 'li-active' : 'li' " :key="item.id">
						{{item.title}}
					</li>
				</ul>
				<div class="gl-nav-logo flex-between">
					<img src="../assets/img/header/Phone-call2.png" alt="" />
					<span class="gl-nav-logo-span-1">服务热线:</span>
					<span class="gl-nav-logo-span-2">158-3000-0223</span>
					<div class="button pointer-hover" v-if="!token">
						<span @click="gologin()">登录</span>/ <span @click="goregister()">注册</span>
					</div>
					<div class="button pointer-hover" @click="myauction()" v-else>
						<span>个人中心</span>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		mapActions,
		mapMutations
	} from 'vuex';
	export default {
		data() {
			return {
				navBarList: [{
						id: 0,
						title: '首页',
						path: '/',
						isActive: false
					},
					{
						id: 1,
						title: '标的大厅',
						path: '/corpore',
						isActive: false
					},
					{
						id: 2,
						title: '拍卖会',
						path: '/auction',
						isActive: false
					},
					{
						id: 3,
						title: '拍卖公告',
						path: '/notice',
						isActive: false
					},
					{
						id: 4,
						title: '金属行情',
						path: '/pricing',
						isActive: false
					},
					{
						id: 5,
						title: '企业专场',
						path: '/enterprise',
						isActive: false
					},
					{
						id: 6,
						title: '联系我们',
						path: '/contactMe',
						isActive: false
					}
				],
				keyWord: null, //input搜索值
			}
		},
		computed: {
			token() {
				return this.$store.state.user.token;
			},
			userInfo() {
				return JSON.parse(this.$store.state.user.user);
			}
		},
		created() {
			// 菜单高亮
			this.navBarList.forEach(item => {
				if (item.title === this.$route.meta.title) {
					item.isActive = true;
				}
			})
		},
		methods: {
			// 登录事件
			gologin() {
				this.$router.push({
					path: '/login',
					query: {
						redirect: this.$route.fullPath
					}
				})
			},
			// 注册事件
			goregister() {
				this.$router.push('/register')
			},
			// 我的拍卖
			myauction() {
				if (this.token) {
					this.$router.push('/user')
				} else {
					this.gologin();
				}
			},
			// 帮助中心
			helpcenter() {
				this.$router.push('/helpCenter')
				console.log('点击帮助中心')
			},
			// 点击/ipnut回车所搜
			handleSearch() {

				// console.log('点击/ipnut回车所搜');

				// this.keyWord = null;
				const keyword = (this.keyWord || '').trim()
				this.$router.push({
					path: '/corpore',
					query: {
						keyword: keyword || undefined
					}
				})
			},
			// 点击导航菜单
			navigation(item) {
				if (item.isActive === false) {
					this.navBarList.forEach(i => {
						i.isActive = false;
					});
					item.isActive = true;
					this.$router.push(item.path)
				}
			},
			// 退出登录
			logout() {
				this.$confirm('确定退出登录？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 调用vuex两个退出action
					this.$store.dispatch('user/logout');
					this.$store.dispatch('user/logoutUser');

					this.$message.success('退出成功');
					// 跳转到首页，再刷新页面
					this.$router.push('/').then(() => {
						location.reload();
					});
				}).catch(() => {
					// 取消操作不做处理
				});
			}
		}
	}
</script>

<style scoped lang="scss">
	#header {
		width: 100%;
		background-color: #F5F5F5;
		height: 163px;
		border-bottom: 3px solid #0E71BC;

		.target {
			width: 1400px;
			height: 30px;
			margin: 0 auto;

			.target-p {
				font-size: 12px;

			}

			.target-div {
				font-size: 12px;
				color: #333333;

				img {
					width: 14px;
					height: 14px;
					margin-left: 4px;
				}

				span {
					margin-left: 4px;
					color: #666666;
				}

				.spacer {
					display: block;
					width: 0px;
					height: 10px;
					border: 1px solid #666666;
					opacity: 0.5;
				}
			}
		}

		.header {
			width: 100%;
			height: 130px;
			overflow: hidden;
			background-color: #fff;


			.gl-logo-searh {
				width: 1400px;
				height: 50px;
				margin: 0 auto;
				margin-top: 17px;

				.gl-logo-searh-left {
					width: 413px;
					height: 50px;

					.logo {
						display: inline-block;
						width: 169px;
						height: 50px;
						background-image: url("../assets/logo.png");
						background-repeat: no-repeat;
						background-size: contain;
						background-position: left center;
						// background-color: beige;
					}

					ul {
						width: 224px;
						height: 50px;
						color: $color-font;
						font-size: 16px;
						font-weight: bold;

						span {
							display: block;
							width: 0px;
							height: 16px;
							border: 1px solid #0E71BC;
						}
					}
				}

				.gl-logo-search-right {
					width: 500px;
					height: 48px;
					padding-left: 20px;
					padding-right: 3px;
					border-radius: 56px 56px 56px 56px;
					border: 2px solid #0E71BC;

					.input-search {
						width: 350px;
						height: 100%;
						border: none;
						font-size: 16px;
						color: #666;
					}

					.search {
						width: 40px;
						height: 40px;
						border-radius: 50%;
						background-color: #0E71BC;

						img {
							width: 20px;
							height: 20px;
						}
					}
				}
			}

			.gl-nav {
				width: 1400px;
				height: 38px;
				margin: 0 auto;
				margin-top: 16px;

				ul {
					width: 784px;
					height: 38px;

					li {
						flex: 1;
						height: 100%;
						display: block;
						color: #333333;
						font-size: 16px;
						text-align: center;
						line-height: 38px;


					}

					.li {
						cursor: pointer;
						transition: all 0.26s ease;
						border-radius: 56px;

						&:hover {

							background: linear-gradient(135deg, #0E71BC, #238cd8);
							color: #ffffff;
							box-shadow: 0 5px 15px rgba(14, 113, 188, 0.4);
						}
					}

					.li-active {
						border-radius: 56px;
						background-color: #0E71BC;
						color: #fff;
						box-shadow: 0 4px 12px rgba(14, 113, 188, 0.35);

					}
				}

				.gl-nav-logo {
					width: 425px;
					height: 38px;
					align-items: center;

					img {
						width: 22px;
						height: 22px;
					}

					.gl-nav-logo-span-1 {
						font-weight: 400;
						font-size: 20px;
						color: #333333;
					}

					.gl-nav-logo-span-2 {
						font-weight: 500;
						font-size: 22px;
						color: $color-font;
					}

					.button {
						width: 124px;
						height: 38px;
						background: #0E71BC;
						border-radius: 45px;
						text-align: center;
						line-height: 38px;
						color: #fff;
						font-size: 16px;
					}

				}
			}
		}
	}
</style>